import { Button, MenuItem, TextField } from "@mui/material";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { useStyles } from "./styles";

interface IFilter {
  family: string;
  project: string;
}

interface ProjectListFilter {
  filter: IFilter;
  onChangeFilter: Dispatch<SetStateAction<IFilter>>;
  onClear: () => void;
}

const ProjectListFilter: React.FC<ProjectListFilter> = ({
  filter,
  onClear,
  onChangeFilter,
}) => {
  const classes = useStyles();

  const handleChangeProject = (e: ChangeEvent<HTMLInputElement>) =>
    onChangeFilter((prev) => ({
      ...prev,
      project: e.target.value,
    }));

  const handleChangeFamily = (e: ChangeEvent<HTMLInputElement>) =>
    onChangeFilter((prev) => ({
      ...prev,
      family: e.target.value,
    }));

  return (
    <div className={classes.root}>
      <div className={classes.filter}>
        <TextField
          id="projeto"
          label="Automações"
          defaultValue="Todos"
          sx={{ width: "280px" }}
          onChange={handleChangeProject}
          value={filter.project}
          select
        >
          <MenuItem value={"Todos"}>Todos</MenuItem>
        </TextField>
        <TextField
          id="familia"
          label="Processos"
          defaultValue="Todos"
          sx={{ width: "280px" }}
          onChange={handleChangeFamily}
          value={filter.family}
          select
        >
          <MenuItem value={"Todos"}>Todos</MenuItem>
        </TextField>
      </div>

      <Button
        variant="contained"
        color="primary"
        size="medium"
        onClick={onClear}
        disabled={filter.family === "Todos" && filter.project === "Todos"}
      >
        Limpar Filtro
      </Button>
    </div>
  );
};

export default ProjectListFilter;
